<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="showConsumables ? 'Add Item' : 'Add Asset'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper>

      @if (loaded) {
        @if (hasNoItemsOrMap) {
          <tidy-card>
            <tidy-row [align]="'center'" class="extra-bottom-padding">
              <tidy-text
                [title]="'Get Map & Maintenance Plan'" />
            </tidy-row>
            <tidy-row [align]="'center'" class="extra-bottom-padding">
              <tidy-text
                [body]="'Instead of adding a single item to your home, you can scan your property and we will generate a fun map of your property and personalized maintenance plan, for free!'" />
            </tidy-row>
            <tidy-row>
              <ion-row>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/house-sketch.svg'"
                    style="width:40px;height:50px" />
                </tidy-row>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="'Create a Sharable Map'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Your map will be with your checklist to help your pro visually get the job done right.'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
            <tidy-row>
              <ion-row>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/tool-box.svg'"
                    style="width:40px;height:50px" />
                </tidy-row>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="'Get Maintenance Tips'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'We will tell you what the manufacturer recommends for each item.'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
            <tidy-row>
              <ion-row>
                <tidy-row class="vertical-align-center">
                  <tidy-image
                    [src]="'assets/img/light-bulb.svg'"
                    style="width:40px;height:50px" />
                </tidy-row>
                <ion-col>
                  <tidy-row>
                    <tidy-text
                      [header]="'Clean Smarter'" />
                  </tidy-row>
                  <tidy-row>
                    <tidy-text
                      [body]="'Knowing what is in your home helps you and any pros you use follow best practices for that exact thing.'" />
                  </tidy-row>
                </ion-col>
              </ion-row>
            </tidy-row>
            <tidy-row>
              <tidy-button
                [text]="'Scan Your Property'"
                [action]="boundBeginMapping"
                class="primary" />
            </tidy-row>
            <tidy-row>
              <tidy-button
                [text]="showConsumables ? 'Add Item' : 'Add Asset'"
                [action]="boundDontScanHome"
                class="secondary" />
            </tidy-row>
          </tidy-card>
        }
        @if (!hasNoItemsOrMap) {
          @if (!categoryChosen) {
            @if (showAddressSelect && !showConsumables && !addressItems) {
              <tidy-card>
                <tidy-row>
                  <ion-skeleton-text
                    animated="true"
                    style="height: 40px; border-radius: 6px" />
                </tidy-row>
              </tidy-card>
            }
            @if (showAddressSelect && !showConsumables && addressItems?.length) {
              <tidy-card>
                <tidy-row>
                  <tidy-select
                    [icon]="'assets/svg/home.svg'"
                    [label]="'Add to properties'"
                    [form]="form.controls.address"
                    [multiple]="true"
                    formControlName="address"
                    [items]="addressItems"
                    [submitted]="submitted"
                    [errorMessage]="'Please select at least one property.'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [actionBody]="allPropertiesSelected ? 'Deselect All' : 'Select All'"
                    (action)="toggleSelectAllProperties()"
                    class="link" />
                </tidy-row>
              </tidy-card>
            }
            <tidy-row>
              <form [formGroup]="form" novalidate action="#">
                <tidy-search-input
                  formControlName="search"
                  [placeholder]="'Search'"
                  [icon]="'assets/svg/search-outline.svg'" />
              </form>
            </tidy-row>
            <div class="asset-grid">
              @for (item of categories; track item.id) {
                <div
                  class="asset-grid-item"
                  [ngClass]="{'selected-card': !showConsumables && isCategorySelected(item)}"
                  (click)="showConsumables ? selectCategory(item) : toggleCategorySelection(item)">
                  <img
                    [src]="item?.default_icon_url || 'assets/svg/home-outline.svg'"
                    class="asset-icon"
                    (error)="$event.target.src = 'assets/svg/home-outline.svg'" />
                  <span class="asset-name">{{ item?.name }}</span>
                </div>
              }
            </div>
            @if (!showConsumables && selectedCategories.length > 0) {
              <div class="bulk-add-bar">
                <tidy-button
                  [text]="('Add ' | translate) + selectedCategories.length + (' Assets' | translate)"
                  [action]="boundSaveSelectedAssets"
                  [disabled]="isSavingBulk"
                  class="primary full-width" />
              </div>
            }
          }
        }
      }
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
